import { Box, Typography, Link, alpha } from '@mui/material'
// import { IRule } from '../../../../redux/slices/entityViewSlice'
import { RuleDefinition } from '../../../DTStudio/interfaces'
import { useState } from 'react'
import theme from '../../../../theme/theme'
import { useTranslation } from 'react-i18next'
import { getDisplayNameFromTargetAttribute } from '../../../../utils/MiscellaneousUtils'

interface RuleSummaryProps {
    rules: RuleDefinition[]
}

export const RuleSummary: React.FC<RuleSummaryProps> = ({ rules }) => {
    const { t } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    // For summary, show only the first rule; for expanded, show all rules
    const rulesToShow = expanded ? rules : rules.slice(0, 1)
    return (
        <Box
            sx={{
                background: '#E9F6FF',
                borderRadius: '8px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                p: 1,
                border: '1px solid #E0E3E7',
            }}
        >
            {rulesToShow.map((rule) => {
                const summaryPairs = Object.entries(rule).filter(
                    ([key]) =>
                        key !== 'Rule Name' &&
                        key !== 'ruleId' &&
                        key !== 'ruleTemplateId' &&
                        key !== 'ruleTemplateName' &&
                        !key.endsWith('::S'),
                )
                const summary = summaryPairs
                    .map(([key, value]) => `${key}: ${value}`)
                    .join(', ')
                const targetAttribute = getDisplayNameFromTargetAttribute(
                    rule['targetAttribute::S'],
                )
                return (
                    <Box key={rule.ruleId} sx={{ mb: 2, p: 0 }}>
                        <Box
                            sx={{
                                // display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 500,
                                    fontSize: '13px',
                                    color: '#222',
                                }}
                            >
                                {rule['Rule Name']}
                                {rule['ruleTemplateName'] && (
                                    <Typography
                                        component="span"
                                        sx={{
                                            fontWeight: 400,
                                            fontSize: '13px',
                                            color: '#444',
                                            ml: 0.5,
                                        }}
                                    >
                                        ({rule['ruleTemplateName']})
                                    </Typography>
                                )}
                            </Typography>
                            {targetAttribute && (
                                <Box
                                    component="span"
                                    sx={{
                                        display: 'inline-flex',
                                        backgroundColor: alpha(
                                            theme.palette.primary.main,
                                            0.21,
                                        ),
                                        borderRadius: '4px',
                                        border: '1px solid #e0e0e0',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography
                                        component="span"
                                        sx={{
                                            fontSize: '13px',
                                            color: '#666',
                                            fontWeight: 500,
                                            fontStyle: 'italic',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {targetAttribute}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        <Typography
                            sx={{
                                fontSize: '13px',
                                color: '#444',
                                mt: 1,
                            }}
                        >
                            {summary}
                        </Typography>
                    </Box>
                )
            })}
            {!expanded && rules.length > 1 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 1,
                    }}
                >
                    <Link
                        component="button"
                        underline="none"
                        sx={{
                            fontSize: '13px',
                            color: '#1976d2',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0.5,
                            cursor: 'pointer',
                            border: 'none',
                            background: 'none',
                        }}
                        onClick={() => setExpanded(true)}
                    >
                        Load more...
                    </Link>
                </Box>
            )}
            {!rules?.length && (
                <Box sx={{ display: 'flex' }}>
                    <Typography
                        sx={{
                            fontStyle: 'italic',
                            fontSize: '13px',
                            color: '#222',
                        }}
                    >
                        {t('noRulesAvailable')}
                    </Typography>
                </Box>
            )}
        </Box>
    )
}
